module.exports = __webpack_public_path__ + "img/5f_r_belmont@2x.2ad948e3.png";